import { render, staticRenderFns } from "./EmailTemplateEditPage.vue?vue&type=template&id=9ca1be12&scoped=true&"
import script from "./EmailTemplateEditPage.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplateEditPage.vue?vue&type=style&index=0&id=9ca1be12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca1be12",
  null
  
)

export default component.exports